// @flow
import { connect } from 'react-redux';

import EventDrivenPagePromotionalBlock from 'components/billboard/EventDrivenPagePromotionalBlock';
import type { StateProps } from 'components/billboard/EventDrivenPagePromotionalBlock';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    currentCompetitions: state.settingsState.current_competitions,
  })
)(EventDrivenPagePromotionalBlock);